var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 27,
    viewBox: "0 0 39 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 17.725C38.5 18.7 36.6 19.35 34.3833 19.675C32.9583 16.9125 30.1083 14.8 26.7833 13.3375C27.1 12.85 27.4167 12.525 27.7333 12.0375H29C33.9083 11.875 38.5 14.9625 38.5 17.725ZM11.2667 11.875H10C5.09167 11.875 0.5 14.9625 0.5 17.725C0.5 18.7 2.4 19.35 4.61667 19.675C6.04167 16.9125 8.89167 14.8 12.2167 13.3375L11.2667 11.875ZM19.5 13.5C22.9833 13.5 25.8333 10.575 25.8333 7C25.8333 3.425 22.9833 0.5 19.5 0.5C16.0167 0.5 13.1667 3.425 13.1667 7C13.1667 10.575 16.0167 13.5 19.5 13.5ZM19.5 15.125C13.0083 15.125 6.83333 19.35 6.83333 23.25C6.83333 26.5 19.5 26.5 19.5 26.5C19.5 26.5 32.1667 26.5 32.1667 23.25C32.1667 19.35 25.9917 15.125 19.5 15.125ZM28.525 10.25H29C31.6917 10.25 33.75 8.1375 33.75 5.375C33.75 2.6125 31.6917 0.5 29 0.5C28.2083 0.5 27.575 0.6625 26.9417 0.9875C28.2083 2.6125 29 4.725 29 7C29 8.1375 28.8417 9.275 28.525 10.25ZM10 10.25H10.475C10.1583 9.275 10 8.1375 10 7C10 4.725 10.7917 2.6125 12.0583 0.9875C11.425 0.6625 10.7917 0.5 10 0.5C7.30833 0.5 5.25 2.6125 5.25 5.375C5.25 8.1375 7.30833 10.25 10 10.25Z",
    fill: "#5C5470"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.a3743884c84d952dfa53325c170df9db.svg";
export { ForwardRef as ReactComponent };